// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/Modal/Modal.sass
// module id = 470
// module chunks = 0